export const createThunk = ({ apiCall, type }) => {
  return requestPayload => (dispatch, getState) => {
    // Handle sessionStorage empty case
    const accessToken = sessionStorage.getItem('access_token') || '';
    const userId = sessionStorage.getItem('user_id') || '';
    const safePayload = {
      ...requestPayload,
      accessToken,
      userId,
    };
 
    dispatch({ payload: safePayload, type });
 
    return apiCall({ getState, payload: safePayload }).then(
      payload => {
        dispatch({ type: `${type}_SUCCESS`, payload, requestPayload: safePayload });
        return payload;
      },
      error => {
        const errorMessage = error?.response?.data?.message || error.message || 'Unknown error';
        const errorPayload = {
          message: errorMessage,
          status: error?.response?.status || 500,
          raw: error,
        };
 
        sessionStorage.setItem(`[Thunk Error] ${type}_FAILURE:`, errorPayload);
 
        dispatch({ type: `${type}_FAILURE`, payload: errorPayload, requestPayload: safePayload });
        return Promise.reject(errorPayload);
      }
    );
  };
};

export const createRejectableThunk = ({ apiCall, type }) => {
  return requestPayload => (dispatch, getState) => {
    dispatch({ payload: requestPayload, type });

    return apiCall({ getState, payload: requestPayload }).then(payload =>
      dispatch({ type: `${type}_SUCCESS`, payload, requestPayload }),
    );
  };
};
